import React, { useState, useEffect } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  FileTextOutlined,
  DashboardOutlined,
  BookOutlined,
  SettingOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { Routes, Route, useNavigate, useLocation } from "react-router"
import { Breadcrumb, Button, Layout, Menu, theme } from 'antd';
import Dashboard from './Views/Dashboard';
import Settings from './Views/Settings';
import Reports from './Views/Reports';
import Tickets from './Views/Tickets';
import { Typography } from 'antd';
import { useBreakpoint } from './utils/breakpoint';
const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileSidebarOpen(false);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle GitHub Pages 404 redirect
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectPath = params.get('p');
    if (redirectPath) {
      navigate(redirectPath + window.location.search.replace('?p=' + redirectPath, '') + window.location.hash);
    }
  }, [navigate]);

  // Set document title
  useEffect(() => {
    document.title = 'Ticketing Tool - Support System';
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [pTittle, setPageTittle] = useState('dashboard');
  const setTitle = (val) => {
    val = val !== '' ? val.replace('/', '') : '';
    setPageTittle(val);
    // Close mobile sidebar after navigation
    if (isMobile) {
      setMobileSidebarOpen(false);
    }
  }

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleMenuClick = (e) => {
    navigate(e.key);
    setTitle(e.key);
  };

  return (
    <div className="App" style={{ margin: 0, padding: 0 }}>
      <Layout style={{ minHeight: '100vh' }}>
        {/* Mobile Sidebar Overlay */}
        {isMobile && (
          <div 
            className={`mobile-sidebar-overlay ${mobileSidebarOpen ? 'show' : ''}`}
            onClick={toggleMobileSidebar}
          />
        )}
        
        <Sider 
          trigger={null} 
          collapsible 
          collapsed={isMobile ? false : collapsed} 
          className={`slider ${collapsed && !isMobile ? 'slider-min' : 'slider-max'} ${isMobile && mobileSidebarOpen ? 'mobile-open' : ''}`}
          style={{
            position: isMobile ? 'fixed' : 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: isMobile ? 11 : 11
          }}
        >
          {!isMobile && (
            <div className="sidebar-header" style={{ 
              padding: collapsed ? '16px 8px' : '16px 24px', 
              borderBottom: '1px solid #303030',
              textAlign: 'center'
            }}>
              <Title 
                level={collapsed ? 5 : 4} 
                style={{ 
                  color: '#ffffff', 
                  margin: 0,
                  fontSize: collapsed ? '14px' : '18px',
                  fontWeight: 'bold'
                }}
              >
                {collapsed ? 'TT' : 'Ticketing Tool'}
              </Title>
              {!collapsed && (
                <div style={{ 
                  color: '#8c8c8c', 
                  fontSize: '12px',
                }}>
                </div>
              )}
            </div>
          )}
          
          {isMobile && (
            <div className="sidebar-header" style={{ 
              padding: '16px 24px', 
              borderBottom: '1px solid #303030',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Title 
                level={4} 
                style={{ 
                  color: '#ffffff', 
                  margin: 0,
                  fontSize: '18px',
                  fontWeight: 'bold'
                }}
              >
                Ticketing Tool
              </Title>
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={toggleMobileSidebar}
                style={{
                  color: '#ffffff',
                  fontSize: '16px',
                  width: 40,
                  height: 40,
                }}
              />
            </div>
          )}
          
          <Menu
            theme="dark"
            defaultSelectedKeys={['/dashboard']}
            onClick={handleMenuClick}
            items={[
              {
                key: '/dashboard',
                icon: <DashboardOutlined />,
                label: 'Dashboard',
              },
              {
                key: '/tickets',
                icon: <FileTextOutlined />,
                label: 'Tickets',
              },
              {
                key: '/reports',
                icon: <BookOutlined />,
                label: 'Reports',
              },
              {
                key: '/settings',
                icon: <SettingOutlined />,
                label: 'Settings',
              }
            ]}
          />
        </Sider>
        
        <Layout style={{ 
          marginLeft: isMobile ? 0 : (collapsed ? '68px' : '240px'), 
          transition: 'marginLeft 0.2s', 
          marginBottom:'30px' 
        }}>
          <Header style={{ padding: 0, background: colorBgContainer }}>
            <Button
              type="text"
              icon={isMobile ? <MenuUnfoldOutlined /> : (collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />)}
              onClick={isMobile ? toggleMobileSidebar : () => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
          </Header>
          <Title level={4} className='page-title'>{pTittle}</Title>
          <Content style={{ margin: '0 16px 0 16px', minHeight: 0, flex: 1 }}>
            <Routes>
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path="/tickets" element={<Tickets />} />
              <Route exact path="/reports" element={<Reports />} />
              <Route exact path="/settings" element={<Settings />} />
              <Route exact path="*" element={<Dashboard />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default App;